import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, inject, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { globals, TwoFactorOption, VerificationType } from '../../globals';

@Component({
  selector: 'ez-two-factor-selection',
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatRadioModule,
    ReactiveFormsModule,
  ],
  templateUrl: './two-factor-selection.component.html',
  styleUrls: ['./two-factor-selection.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TwoFactorSelectionComponent implements OnInit {
  options: TwoFactorOption[] = [];
  success: boolean;
  errorMessage: string;

  readonly #fb = inject(FormBuilder);
  form;

  constructor(elementRef: ElementRef) {
    const getAttribute = elementRef.nativeElement.getAttribute.bind(elementRef.nativeElement);

    this.success = getAttribute('success') === 'success';
    this.errorMessage = getAttribute('error-message');

    this.form = this.#fb.group({
      verificationType: [VerificationType.SMS, Validators.required],
    });
  }

  ngOnInit(): void {
    this.options = globals.twoFactorOptions;

    const checkedOption = this.options.find(option => option.checked);
    const formValue = checkedOption
      ? checkedOption.verificationType
      : null;

    this.form.controls.verificationType.setValue(formValue);
  }
}
